import {Locales} from '@netx/core-next/locales/utils/Locales';
import {FileSizeType, FileSizeMetric} from './constants';

export const FileSizeTypeLabel: Record<FileSizeType, string> = Locales(
	(i18n) => ({
		[FileSizeType.APPROXIMATELY]: i18n('i18n.approximately'),
		[FileSizeType.EQUAL_TO]: i18n('i18n.equalTo'),
		[FileSizeType.GREATER_THAN]: i18n('i18n.greaterThan'),
		[FileSizeType.LESS_THAN]: i18n('i18n.lessThan'),
	}),
);

export const FileSizeSubTypeLabel: Record<FileSizeMetric, string> = Locales(
	(i18n) => ({
		[FileSizeMetric.BYTES]: i18n('i18n.unitBytes'),
		[FileSizeMetric.GBYTES]: i18n('i18n.unitGbytes'),
		[FileSizeMetric.KBYTES]: i18n('i18n.unitKbytes'),
		[FileSizeMetric.MBYTES]: i18n('i18n.unitMbytes'),
	}),
);
